import React, { Component } from 'react';
import { connect } from 'react-redux';
import { apiGetAllCategories } from '../../Api/Documents/Documents';
import { ListDocumentTemplate } from '../../Templates';
import formatCategories from '../../Utils/formatCategories';
import DocumentsService from '../../Services/DocumentsService';
import Store from '../../Redux/Store';

const MENUS = [
  {
    id: 'send-documents-item',
    name: 'Envoyer un document',
    parentId: null,
    canSend: false,
    route: 'documents/send'
  },
  {
    id: 'contracts',
    name: 'Contrat',
    parentId: null,
    canSend: false,
    route: 'documents/contracts'
  },
  {
    id: 'sent-documents-item',
    name: 'Documents envoyés',
    parentId: null,
    canSend: false,
    route: 'contact?subject=demandes'
  }
];

class ListDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      contractFamily: Store.getState()?.auth?.user?.contractTypes
    };
  }

  onChangeRoute = (link, data = '') => {
    this.props.history.push(link);
    if (data) {
      this.props.dispatch({
        type: 'SET_DOCUMENT_CATEGORY',
        value: { data: data }
      });
    }
  };

  componentDidMount() {
    this.getAllCategories();
  }

  getAllCategories = async () => {
    const categories = await DocumentsService.getAllCategories();
  };

  render() {
    return (
      <ListDocumentTemplate onChangeRoute={this.onChangeRoute} data={MENUS} />
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: (action) => {
      dispatch(action);
    }
  };
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  categories: state.DocumentsReducer.categories
});
export default connect(mapStateToProps, mapDispatchToProps)(ListDocument);
